/**
 * Vishram — hero carousel
 * Autoplay that pauses on hover/focus and stops entirely under
 * prefers-reduced-motion. Dots + arrows + keyboard (left/right when focused).
 * Isolated in try/catch so a failure here can't take down other modules.
 */
(function () {
  'use strict';
  if (window.__vishramCarouselInit) { return; }
  window.__vishramCarouselInit = true;

  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-vishram-carousel]'));

    for (var r = 0; r < roots.length; r++) {
      (function (root) {
        var track = root.querySelector('[data-carousel-track]');
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
        var prev = root.querySelector('[data-carousel-prev]');
        var next = root.querySelector('[data-carousel-next]');
        if (!track || slides.length < 2) { return; }

        var index = 0;
        var count = slides.length;
        var timer = null;
        var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

        function render() {
          track.style.transform = 'translateX(-' + (index * 100) + '%)';
          for (var i = 0; i < dots.length; i++) {
            if (i === index) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
            else { dots[i].classList.remove('is-active'); dots[i].removeAttribute('aria-current'); }
          }
          for (var s = 0; s < slides.length; s++) {
            slides[s].setAttribute('aria-hidden', s === index ? 'false' : 'true');
          }
        }
        function go(i) { index = (i + count) % count; render(); }
        function start() { if (reduce || timer) { return; } timer = window.setInterval(function () { go(index + 1); }, interval); }
        function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

        if (next) { next.addEventListener('click', function () { go(index + 1); stop(); start(); }); }
        if (prev) { prev.addEventListener('click', function () { go(index - 1); stop(); start(); }); }
        for (var d = 0; d < dots.length; d++) {
          (function (di) { dots[di].addEventListener('click', function () { go(di); stop(); start(); }); })(d);
        }
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        root.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.keyCode === 39) { go(index + 1); stop(); start(); }
          else if (e.key === 'ArrowLeft' || e.keyCode === 37) { go(index - 1); stop(); start(); }
        });

        render();
        start();
      })(roots[r]);
    }
  } catch (err) {
    if (window.console && window.console.error) { window.console.error('vishram carousel error', err); }
  }
})();
